import React from 'react';
import {moneyShownToString} from './lib/money';
import {answerConfirm} from './lib/money';

export default class AnswerFeedback extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.visible){
      return (
        <div>
          <p className={this.props.currentAttemptCorrect ?
                      'answer-confirm__correct' : 'answer-confirm__incorrect'}>
            {answerConfirm(this.props.currentAttemptCorrect)}
          </p>
          <p>{moneyShownToString(this.props.gameState)}</p>
        </div>
      );
    }
    else {
      return null;
    }
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/money/answer-feedback.js
 **/